import styled from 'styled-components';

export const ContentSectionWrapper = styled.div`
	margin: 6rem 0;
`;
